// The Bundler app's offer popup (bundles-bundler-hop-*) can leave its full-page overlay on screen after
// the cart drawer closes. Use the app's own close button to dismiss it; no-op when the app isn't showing it.
function dismissBundlerOverlay() {
  if (!document.querySelector('.bundles-bundler-hop-full-page-overlay.bundles-bundler-hop-visible')) return;
  const closeButton = document.querySelector('.bundles-bundler-hop-x-button');
  if (closeButton) closeButton.click();
}

// Tapping the dimmed area itself (not the popup content) dismisses a stuck overlay.
document.addEventListener('click', (event) => {
  if (event.target.classList && event.target.classList.contains('bundles-bundler-hop-full-page-overlay')) {
    dismissBundlerOverlay();
  }
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    dismissBundlerOverlay();
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('click', async (e) => {
  const upsellArea = e.target.closest('[data-upsells]');
  const btn = e.target.closest('.upsell-atc');
  if (!upsellArea || !btn) return;
  if (btn.dataset.busy === '1') return;      // <-- guard
  btn.dataset.busy = '1';                    // <-- set guard
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
// --- find a variant id from the upsell form or button ---
const form = btn.closest('form');
let variantId = null;
// from <select name="id"> or <input name="id">
if (form) {
  const fd = new FormData(form);
  variantId = fd.get('id');
}
// fallback to data attributes on the button
if (!variantId) variantId = btn.dataset.variantId || btn.dataset.defaultId;
// if still none, prompt the user and bail
if (!variantId) {
  btn.textContent = 'Select option';
  setTimeout(() => (btn.textContent = 'Add to cart'), 1200);
  btn.disabled = false;
  delete btn.dataset.busy;
  return;
}
// optional: selling plan if your upsell form has one
let sellingPlanId = null;
if (form) {
  const fd2 = new FormData(form);
  sellingPlanId = fd2.get('selling_plan');
}
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  try {
    const payload = { id: String(variantId), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
    if (sellingPlanId) payload.selling_plan = String(sellingPlanId);
    const add = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
    if (!add.ok) throw new Error(await add.text());
    // refresh the drawer and cart count from the sections returned by /cart/add.js
    const added = await add.json();
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && added.sections) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(added);
    }
    btn.textContent = 'Added!';
    setTimeout(() => (btn.textContent = original), 1200);
  } catch (err) {
    console.error('Upsell add error:', err);
    btn.textContent = 'Error';
    setTimeout(() => (btn.textContent = original), 1500);
  } finally {
    btn.disabled = false;
    delete btn.dataset.busy;                 // <-- release guard
  }
});
// ===== Upsell Add-to-Cart (AJAX, no redirect) =====
document.addEventListener('click', async (e) => {
  // Only run for clicks inside the upsell area and on upsell buttons
  const upsellArea = e.target.closest('[data-upsells]');
  const btn = e.target.closest('.upsell-atc');
  if (!upsellArea || !btn) return;
  // Block form submission + any parent handlers (prevents navigation)
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  // 1) Get a variant id (from select/hidden OR button data)
  const form = btn.closest('form');
  let variantId = null;
  if (form) {
    const fd = new FormData(form);
    variantId = fd.get('id'); // select/hidden/radio named "id"
  }
  if (!variantId) variantId = btn.dataset.variantId || btn.dataset.defaultId;
  if (!variantId) { btn.textContent = 'Select option'; setTimeout(()=>btn.textContent='Add to cart',1200); return; }
  variantId = String(variantId).trim();
  // Optional: selling plan support (ignored if not present)
  let sellingPlanId = null;
  if (form) {
    const fd = new FormData(form);
    sellingPlanId = fd.get('selling_plan');
  }
  // 2) UI feedback
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  try {
    // 3) Add the item (ID must be sent as STRING)
    const payload = { id: variantId, quantity: 1 };
    if (sellingPlanId) payload.selling_plan = String(sellingPlanId);
    const add = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });
    if (!add.ok) {
      const msg = await add.text();
      throw new Error(msg || 'Add failed');
    }
    // 4) Refresh the drawer contents (Dawn + clones)
    const tryRenderContents = async () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.renderContents === 'function') {
        await drawer.renderContents();
    drawer.open?.();
    return true;
  }
      return false;
    };
    const trySectionsAPI = async () => {
  const handles = ['cart-drawer','cart-drawer-items','cart-icon-bubble'];
  const url = new URL(window.location.href);
  url.searchParams.set('sections', handles.join(','));
      const resp = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
  const data = await resp.json().catch(() => ({}));
  let updated = false;
      const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
      if (drawer && data['cart-drawer']) { drawer.innerHTML = data['cart-drawer']; updated = true; }
      const items = document.querySelector('cart-drawer-items');
      if (items && data['cart-drawer-items']) { items.innerHTML = data['cart-drawer-items']; updated = true; }
      const bubble = document.querySelector('[data-cart-count-bubble]') || document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) { bubble.innerHTML = data['cart-icon-bubble']; updated = true; }
      (document.querySelector('cart-drawer') || drawer)?.open?.();
  if (updated) document.body.classList.add('overflow-hidden','drawer-open');
  return updated;
    };
    const tryCountOnly = async () => {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      const bubble = document.querySelector('[data-cart-count-bubble] .count');
      if (bubble) bubble.textContent = cart.item_count;
      return true;
    };
    const withTimeout = (p, ms) => Promise.race([ p, new Promise(res => setTimeout(()=>res(false), ms)) ]);
    await withTimeout(tryRenderContents(), 1000) ||
    await withTimeout(trySectionsAPI(), 1400) ||
    await withTimeout(tryCountOnly(), 700);
    btn.textContent = 'Added!';
    setTimeout(() => (btn.textContent = original), 1200);
  } catch (err) {
    console.error('Upsell add error:', err);
    btn.textContent = 'Error';
    setTimeout(() => (btn.textContent = original), 1500);
  } finally {
    btn.disabled = false;
  }
});
// Checkout button total: the Bundler / Easify / shipping protection apps keep rewriting the price element inside
// #CartDrawer-Checkout (different formats, struck-through values, fee added and removed). That element is hidden
// in CSS and the button shows its own .nrz-checkout-total instead, which only this code writes: the server-rendered
// cart total in the theme's money format, plus the shipping protection fee when its toggle is on.
(function () {
  const MIN_FETCH_GAP = 800;
  let cachedCents = null;
  let cachedText = '';
  let lastFetchAt = 0;
  let timer;
  let busy = false;

  function amountIn(text) {
    const match = text.match(/\d[\d,]*(?:\.\d+)?/);
    return match ? parseFloat(match[0].replace(/,/g, '')) : NaN;
  }

  function formatLike(template, amount) {
    const match = template.match(/\d[\d,]*(?:\.(\d+))?/);
    if (!match) return template;
    const decimals = match[1] ? match[1].length : 0;
    const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    return template.replace(match[0], formatted);
  }

  function protectionFee() {
    const toggle = document.querySelector('.easy-insurance .easy-switch-input-btn');
    const price = document.querySelector('.easy-insurance .easy-price');
    if (!toggle || !toggle.checked || !price) return 0;
    const fee = amountIn(price.textContent);
    return isNaN(fee) ? 0 : fee;
  }

  function render() {
    const button = document.querySelector('#CartDrawer-Checkout');
    if (!button || !cachedText) return;
    let total = button.querySelector('.nrz-checkout-total');
    if (!total) {
      total = document.createElement('span');
      total.className = 'nrz-checkout-total';
      button.appendChild(total);
    }
    const base = amountIn(cachedText);
    const text = isNaN(base) ? cachedText : formatLike(cachedText, base + protectionFee());
    if (total.textContent !== text) total.textContent = text;
  }

  async function sync() {
    if (busy || !document.querySelector('#CartDrawer-Checkout')) return;
    busy = true;
    lastFetchAt = Date.now();
    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      if (cart.total_price !== cachedCents || !cachedText) {
        const sections = await fetch('/?sections=cart-drawer').then((response) => response.json());
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const serverPrice = doc.querySelector('#CartDrawer-Checkout .totals__total-value');
        if (serverPrice) {
          cachedText = serverPrice.textContent.trim();
          cachedCents = cart.total_price;
        }
      }
      render();
    } catch (error) {
      console.error('Checkout total sync error:', error);
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, Math.max(150, MIN_FETCH_GAP - (Date.now() - lastFetchAt)));
  }

  function insideCheckoutButton(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return !!(element && element.closest('#CartDrawer-Checkout'));
  }

  function start() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const initial = drawer.querySelector('#CartDrawer-Checkout .totals__total-value');
    if (initial && !initial.children.length) cachedText = initial.textContent.trim();
    render();
    new MutationObserver((records) => {
      render();
      if (records.some((record) => !insideCheckoutButton(record.target))) schedule();
    }).observe(drawer, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', (event) => {
      if (event.target.classList && event.target.classList.contains('easy-switch-input-btn')) setTimeout(render, 50);
    });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();